import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { GalleryDto } from '@picflow/types';
import { randomString } from 'src/app/lib/random-string';
import { ProTagComponent } from '../../../shared-extra/components/pro-tag/pro-tag.component';
import { PermissionsPipe } from '../../../shared-extra/pipes/permissions.pipe';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ResizeDirective } from '../../../shared/directives/resize.directive';
import { TransitionPreventorDirective } from '../../../shared/directives/transition-preventor.directive';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';

@Component({
  selector: 'app-settings-box',
  templateUrl: './settings-box.component.html',
  styleUrls: ['./settings-box.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    SvgComponent,
    ProTagComponent,
    ResizeDirective,
    ButtonDirective,
    LoadingIndicatorComponent,
    RouterLink,
    TransitionPreventorDirective,
    FormsModule,
    ContextMenuComponent,
    NgFor,
    ButtonMenuItemComponent,
    CapitalizePipe,
    PermissionsPipe,
  ],
})
export class SettingsBoxComponent {
  @Input() ctaText: string;
  @Input() ctaColor: string;
  @Input() title: string;
  @Input() icon: string;
  @Input() iconSize: string;
  @Input() iconStyle: 'normal' | 'circle-bordered' = 'normal';
  @Input() image: string;
  @Input() soon: boolean;
  @Input() soonDontDisable: boolean;
  @Input() first: boolean;
  @Input() last: boolean;
  @Input() name: string;
  @Input() location: string;
  @Input() link: string[];
  @Input() externalLink: string;
  @Input() permission: string;
  @Input() overridePermissionIfTrue: boolean;
  @Input() color: string;
  @Input() primaryHover: boolean;
  @Input() buttonLoading: boolean;
  @Input() arrowCta: boolean;
  @Input() switchCta: boolean;
  @Input() selectCta: boolean;
  @Input() switchValue: boolean;
  @Input() selectValue: string;
  @Input() selectOptions: { text: string; value: string; icon?: string; color?: string; iconColor?: string }[];
  @Input() small: boolean;
  @Input() gallery: GalleryDto;
  @Output() onClick = new EventEmitter();
  @Output() onSwitch = new EventEmitter();

  id = randomString(10);
}
